import { Fragment } from "react";
import { CardBody, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IoCalendarOutline } from "react-icons/io5";
import ParticipantsSection from "./Sections/Participants";
import NotesSection from "../../../../components/Sections/Notes";
import AttachmentsSection from "../../../../components/Sections/Attachments";
import { useSettings } from "../../../../../../context/settings";
import { Field, SectionCard } from "../../../../components/Record";
import { formatMinutes, minutesBetween, personName } from "../../../../utils/helpers";

function OverviewTab({ meetingData }) {
  const { t } = useTranslation();
  const { formatDateTime } = useSettings();

  const customer = meetingData?.customer;
  const customerName = customer?.company_name || personName(customer);
  const duration = minutesBetween(meetingData?.time_from, meetingData?.time_to);

  return (
    <Fragment>
      <SectionCard
        id="meeting-informations-card"
        icon={<IoCalendarOutline size={15} />}
        title={t('crm.meetingInformationsSection')}
      >
        <CardBody>
          <Row className="g-3">
            <Field label={t('contact.title')} value={meetingData?.title} />
            <Field label={t('crm.meetingLocation')} value={meetingData?.location} />
            <Field label={t('crm.host')} value={personName(meetingData?.host)} />
            <Field
              label={t('common.from')}
              value={meetingData?.time_from ? formatDateTime(meetingData.time_from) : null}
            />
            <Field
              label={t('common.to')}
              value={meetingData?.time_to ? formatDateTime(meetingData.time_to) : null}
            />
            <Field label={t('common.duration')} value={formatMinutes(duration)} />
            <Field label={t('crm.relatedTo')}>
              {customer?.id ? (
                <Link
                  to={"/crm/customers/view/" + customer.id}
                  state={{ customerData: customer }}
                  className="crm-record-value text-decoration-none"
                >
                  {customerName}
                </Link>
              ) : meetingData?.lead_id ? (
                <Link to={"/crm/leads/view/" + meetingData.lead_id} className="crm-record-value text-decoration-none">
                  {t('crm.lead')}
                </Link>
              ) : (
                <div className="crm-record-value">-</div>
              )}
            </Field>
            <Field label={t('timeline.createdBy')} value={personName(meetingData?.created_by)} />
            <Field label={t('common.description')} value={meetingData?.description} lg="12" />
          </Row>
        </CardBody>
      </SectionCard>

      <ParticipantsSection meetingData={meetingData} />

      <NotesSection
        objectData={meetingData}
        objectType="meeting"
      />

      <AttachmentsSection
        objectData={meetingData}
        objectType="meeting"
      />
    </Fragment>
  );
}

export default OverviewTab;
